<template>
<div class="px-1 pt-1">
  <div class="input-group pb-3">
    <button class="btn btn-outline-primary" @click="routeToCreateView()">
      <font-awesome-icon :icon="['fas', 'kit-medical']" />
      {{ $t('action.newEllipsis') }}
    </button>
  </div>

  <ItemBlockList @selected="goToItemBlock" />
</div>
</template>

<script setup lang="ts">
import ItemBlockList from "@/components/masterdata/ItemBlockList.vue";
import { router } from "@/services";

const goToItemBlock = async (itemBlockId: number) => {
  await router.push({ name: 'itemblock', params: { itemBlockId: itemBlockId } });
}

const routeToCreateView = async () => {
  await router.push({ name: 'itemblock-create' });
}
</script>
